import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let belofte = null;

const PUBLIEK = /^\/(klant-portaal|klacht|klachten-portaal|partner-login|pas\/)/;

export function laadFlags(forceer = false) {
  if (cache && !forceer) return Promise.resolve(cache);
  if (PUBLIEK.test(window.location.pathname) && !localStorage.getItem("token")) return Promise.resolve(cache || {});
  if (!belofte) {
    belofte = api.get("/flags/stand").then((r) => { cache = r.data; window.__bptFlags = cache; return cache; }).catch(() => (cache || {})).finally(() => { belofte = null; });
  }
  return belofte;
}

// Stand van alle feature-flags (één keer per sessie geladen; ververs met herlaad()).
export function useFlags() {
  const [flags, setFlags] = useState(cache || {});
  useEffect(() => { laadFlags().then(setFlags); }, []);
  return { flags, aan: (k) => !!flags[k], herlaad: () => laadFlags(true).then(setFlags) };
}
